'use strict';

angular.module('web2print.recipients')
  .directive('ageValidation', () => ({
    restrict: 'A',
    require: 'ngModel',
    link: (scope, elem, attr, ngModel) => {
      ngModel.$validators.age = age =>
        age >= 16 ||
        age === null || // empty input
        angular.isUndefined(age); // untouched input
    }
  }));
